import React from "react";

import { FormMaskedControl } from "../..";

const FieldInputSSN = ({ field, form, isBank, ...rest }) => {
  return <FormMaskedControl {...field} {...form} {...rest} isBank={isBank} />;
};

export default FieldInputSSN;
